interface ApplicationContainerProps {
    children: React.ReactNode;
}

export const ApplicationContainer = (props: ApplicationContainerProps) => {
    return <div className='size-lf-stretch bg-background-default inline-flex w-full flex-col items-start justify-start gap-6'>{props.children}</div>;
};
